import {BaseContainerModel} from '../../base-container.model';
import {bl_cms_menu_ext_RowClass, } from '../../../dbschema';
import {bl_cms_layout_instance_hdr_RowClass} from '../../../dbschema/bl_cms_layout_instance_hdr.model';

export class CmsLayoutInstanceContainerModel extends BaseContainerModel {

  bl_cms_layout_instance_hdr: bl_cms_layout_instance_hdr_RowClass = new bl_cms_layout_instance_hdr_RowClass();
  // TODO update the type once we create the class
  bl_cms_layout_instance_exts: Array<any> = [];
}
